import { Button, Dialog, LinearProgress, Stack, Typography } from '@mui/material'
import { useEffect, useRef, useState, type ReactNode } from 'react'
import { DialogContent } from '../dialog-componentes'
import CheckIcon from '@mui/icons-material/Check'
import ReplayIcon from '@mui/icons-material/Replay'
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'

export const MS_RESPOSTA_PADRAO = 20000
export interface DialogInatividadeTotemProps {
    aberto: boolean
    mensagem: (segundos: number) => ReactNode
    aoContinuar: () => void
    aoExpirar: () => void
    acaoSecundaria?: { rotulo: string; aoClicar: () => void }
    msResposta?: number
}

export function DialogInatividadeTotem({
    aberto,
    mensagem,
    aoContinuar,
    aoExpirar,
    acaoSecundaria,
    msResposta = MS_RESPOSTA_PADRAO,
}: DialogInatividadeTotemProps): JSX.Element {
    const totalSegundos = Math.ceil(msResposta / 1000)
    const [segundos, setSegundos] = useState(totalSegundos)
    const aoExpirarRef = useRef(aoExpirar)

    useEffect(() => {
        aoExpirarRef.current = aoExpirar
    }, [aoExpirar])

    useEffect(() => {
        if (!aberto) return

        setSegundos(totalSegundos)

        const contagem = window.setInterval(() => setSegundos((s) => Math.max(s - 1, 0)), 1000)
        const expiracao = window.setTimeout(() => aoExpirarRef.current(), msResposta)

        return () => {
            window.clearInterval(contagem)
            window.clearTimeout(expiracao)
        }
    }, [aberto, msResposta, totalSegundos])

    return (
        <Dialog open={aberto} maxWidth="sm" fullWidth slotProps={{ paper: { sx: { borderRadius: 4, p: 2 } } }}>
            <DialogContent>
                <Stack spacing={3} sx={{ alignItems: 'center', textAlign: 'center' }}>
                    <AccessTimeRoundedIcon color="primary" sx={{ fontSize: 88 }} />

                    <Stack spacing={1} sx={{ alignItems: 'center' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                            Você ainda está aí?
                        </Typography>

                        <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 500 }}>
                            {mensagem(segundos)}
                        </Typography>
                    </Stack>

                    <LinearProgress
                        variant="determinate"
                        value={(segundos / totalSegundos) * 100}
                        sx={{ width: '100%', height: 10, borderRadius: 5 }}
                    />

                    <Stack spacing={2} sx={{ width: '100%' }}>
                        <Button
                            variant="contained"
                            size="large"
                            fullWidth
                            onClick={aoContinuar}
                            startIcon={<CheckIcon fontSize="large" />}
                            sx={{ minHeight: 76, borderRadius: 3, textTransform: 'none' }}
                        >
                            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                                Estou aqui, continuar
                            </Typography>
                        </Button>

                        {acaoSecundaria && (
                            <Button
                                variant="outlined"
                                size="large"
                                fullWidth
                                onClick={acaoSecundaria.aoClicar}
                                startIcon={<ReplayIcon fontSize="large" />}
                                sx={{ minHeight: 76, borderRadius: 3, textTransform: 'none' }}
                            >
                                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                                    {acaoSecundaria.rotulo}
                                </Typography>
                            </Button>
                        )}
                    </Stack>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

export default DialogInatividadeTotem
